"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Modal = require("react-modal");
const dateFormat = require("dateformat");
const react_slick_1 = require("react-slick");
function PortfolioModal(props) {
    Modal.setAppElement('#portfolios');
    const customStyles = {
        overlay: {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            zIndex: '5',
        },
        content: {},
    };
    // todo: animation
    return (React.createElement(Modal, { isOpen: props.modalIsOpen, className: 'page-ajax-loaded animated fadeInLeft', onRequestClose: props.closeModal, style: customStyles, contentLabel: 'Example Modal' },
        React.createElement("div", { id: 'portfolio-page', className: 'portfolio-page-content' },
            React.createElement("div", { className: 'container' },
                React.createElement("div", { className: 'portfolio-nav' },
                    React.createElement("div", { id: 'portfolio-close-button', className: 'portfolio-close-button' },
                        React.createElement("a", { onClick: (e) => props.closeModal(e), href: '#portfolio' },
                            React.createElement("i", { className: 'fa fa-close' })))),
                React.createElement("div", { className: 'portfolio-title' },
                    React.createElement("h1", null, props.portfolio.title)),
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-sm-7 col-md-7 portfolio-block' },
                        React.createElement(RenderImages, { images: props.portfolio.images.map((e) => e.secure_url) })),
                    React.createElement("div", { className: 'col-sm-5 col-md-5 portfolio-block' },
                        React.createElement("div", { className: 'block-title' },
                            React.createElement("h3", null, "Description")),
                        React.createElement("ul", { className: 'project-general-info' },
                            props.portfolio.siteUrl
                                && React.createElement("li", null,
                                    React.createElement("p", null,
                                        React.createElement("i", { className: 'fa fa-globe' }),
                                        React.createElement("a", { href: props.portfolio.siteUrl, target: '_blank' }, props.portfolio.siteUrl))),
                            props.portfolio.githubUrl
                                && React.createElement("li", null,
                                    React.createElement("p", null,
                                        React.createElement("i", { className: 'fa fa-github' }),
                                        React.createElement("a", { href: props.portfolio.githubUrl, target: '_blank' }, props.portfolio.githubUrl))),
                            React.createElement("li", null,
                                React.createElement("p", null,
                                    React.createElement("i", { className: 'fa fa-calendar' }),
                                    " ",
                                    dateFormat(props.portfolio.publishedDate, 'mmmm dS, yyyy')))),
                        React.createElement("p", { className: 'text-justify' }, props.portfolio.description),
                        React.createElement("div", { className: 'tags-block' },
                            React.createElement("div", { className: 'block-title' },
                                React.createElement("h3", null, "Technology")),
                            props.portfolio.tags
                                && props.portfolio.tags.length > 0 &&
                                React.createElement("ul", { className: 'tags' }, props.portfolio.tags.map((tag) => {
                                    return (React.createElement("li", { key: tag },
                                        React.createElement("a", null, tag)));
                                })))))))));
}
exports.default = PortfolioModal;
function RenderImages(props) {
    if (props.images.length === 1) {
        return (React.createElement("div", { className: 'item' },
            React.createElement("img", { src: props.images[0], alt: '101' })));
    }
    else {
        const settings = {
            draggable: true,
            autoplay: true,
            autoplaySpeed: 7000,
            arrows: false,
            dots: false,
            fade: true,
            speed: 500,
            infinite: true,
            cssEase: 'ease-in-out',
            touchThreshold: 100,
        };
        let slider;
        return (React.createElement("div", { className: 'owl-carousel portfolio-page-carousel owl-loaded owl-drag' },
            React.createElement("div", { className: 'owl-stage-outer' },
                React.createElement(react_slick_1.default, Object.assign({ ref: (c) => (slider = c) }, settings, { className: 'owl-stage' }), props.images.map((image) => {
                    return (React.createElement("div", { key: image, className: 'owl-item cloned' },
                        React.createElement("div", { className: 'item' },
                            React.createElement("img", { src: image, alt: '101' }))));
                }))),
            React.createElement("div", { className: 'owl-nav' },
                React.createElement("div", { onClick: (e) => slider.slickPrev(), className: 'owl-prev' }),
                React.createElement("div", { onClick: (e) => slider.slickNext(), className: 'owl-next' }))));
    }
}
